import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router, RouterModule } from "@angular/router";
import * as fabric from "fabric";
import { environment } from "../../../../environments/environment";
import { CommonDialogData } from "../../models/dialog.interface";
import { SharedModule } from "../../shared.module";
import { TranslateModule } from "@ngx-translate/core"; // Nhập khẩu TranslateModule

@Component({
  selector: "app-common-dialog",
  // Thêm TranslateModule vào danh sách imports
  imports: [SharedModule, RouterModule, CommonModule, TranslateModule],
  templateUrl: "./common-dialog.component.html",
  styleUrl: "./common-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  encapsulation: ViewEncapsulation.Emulated,
})
export class CommonDialogComponent implements AfterViewInit {
  @ViewChild("hiddenCanvas")
  private hiddenCanvas!: ElementRef<HTMLCanvasElement>;
  private hiddenCanva!: fabric.Canvas;
  host_url = environment.apiURL;

  constructor(
    public dialogRef: MatDialogRef<CommonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CommonDialogData,
    private router: Router
  ) {}

  ngAfterViewInit() {
    if (this.data.loadSpecificContent === "canvas") {
      // Compute actual preview canvas size to fit the dialog on any screen.
      // Dialog config: width=92vw, maxWidth=640px; padding: 24px×2 (desktop) / 20px×2 (mobile ≤768px)
      const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 640;
      const dialogWidth = Math.min(viewportWidth * 0.92, 640);
      const horizontalPadding = viewportWidth <= 768 ? 40 : 48;
      const canvasSize = Math.min(500, Math.max(200, Math.floor(dialogWidth - horizontalPadding)));
      const rate = canvasSize / 800;

      // Apply canvas size before Fabric initializes
      this.hiddenCanvas.nativeElement.setAttribute('width', String(canvasSize));
      this.hiddenCanvas.nativeElement.setAttribute('height', String(canvasSize));

      this.hiddenCanva = new fabric.Canvas(this.hiddenCanvas.nativeElement, {
        width: canvasSize,
        height: canvasSize,
      });

      this.data.content.objects = this.data.content.objects.map((object: any) => {
        const clipPath = object.clipPath;
        return {
          ...object,
          selectable: false,
          scaleX: object.scaleX * rate,
          scaleY: object.scaleY * rate,
          top: object.top * rate,
          left: object.left * rate,
          clipPath: clipPath ? {
            ...clipPath,
            top: clipPath.top * rate,
            left: clipPath.left * rate,
            width: clipPath.width * rate,
            height: clipPath.height * rate,
          } : null,
        };
      });

      if (this.data.content) {
        this.hiddenCanva.loadFromJSON(this.data.content, () => {
          try {
            setTimeout(() => {
              this.hiddenCanva.renderAll();
            }, 100);
          } catch (_) {
            this.hiddenCanva.renderAll();
          }
        });
      }
    }
  }

  onNavigate() {
    const path = this.data.redirectTo;
    if (!path || path === "#") {
      return this.dialogRef.close("confirm");
    }
    this.router.navigateByUrl(path);
  }

  // Giữ nguyên hàm normalizePreviewCanvas của bạn
  private normalizePreviewCanvas(): void {
    if (!this.hiddenCanva) return;
    const objs = this.hiddenCanva.getObjects();
    if (!objs || !objs.length) return;

    const images = objs.filter((o) => (o as any).type === "image") as any[];
    if (!images.length) return;
    const bgImg = images.reduce((max, cur) => {
      const a = (max?.getScaledWidth?.() || 0) * (max?.getScaledHeight?.() || 0);
      const b = (cur?.getScaledWidth?.() || 0) * (cur?.getScaledHeight?.() || 0);
      return b > a ? cur : max;
    });

    if (!bgImg) return;

    const bgWidth = Math.max(1, Math.round(bgImg.getScaledWidth?.() || bgImg.width || 800));
    const bgHeight = Math.max(1, Math.round(bgImg.getScaledHeight?.() || bgImg.height || 800));

    const dx = -(bgImg.left || 0);
    const dy = -(bgImg.top || 0);
    this.hiddenCanva.getObjects().forEach((o) => {
      try {
        (o as any).left = (o as any).left + dx;
        (o as any).top = (o as any).top + dy;
        (o as any).setCoords?.();
      } catch (_) {}
    });
    
    try {
      bgImg.left = 0;
      bgImg.top = 0;
      bgImg.setCoords?.();
    } catch (_) {}

    this.hiddenCanva.setWidth(bgWidth);
    this.hiddenCanva.setHeight(bgHeight);

    this.hiddenCanvas.nativeElement.style.width = "100%";
    this.hiddenCanvas.nativeElement.style.height = "auto";
  }
  get isLoginPopup(): boolean {
    const path = this.data.redirectTo?.toLowerCase() || '';
    return path.includes('login') || path.includes('auth');
  }
}